<template>
<div class="index">
    <p class="child-title">佳驰电子简介</p>
    <p class="child-sub-title">COMPANY PROFILE</p>
    <div class="box">
        <img src="../../assets/img/main-about.png" alt srcset />
        <p class="title"> {{detail.name}}</p>
        <p class="sub-title">{{detail.ex_title}}</p>
        <p class="rich" v-html="detail.content"></p>
    </div>
</div>
</template>

<script>
import {
    gsjj
} from "../../assets/js/api";
export default {
    data() {
        return {
            detail: {}
        };
    },
    created() {
        gsjj().then((r) => {
            this.detail = r.data;
        });
    },
};
</script>

<style lang="less" scoped>
.box {
    padding: 0 0.3rem;
    box-sizing: border-box;

    img {
        width: 100%;
        margin-bottom: 0.45rem;
    }

    .title {
        font-size: 0.3rem;
        font-family: Source Han Sans CN;
        font-weight: bold;
        color: #126fcc;
        margin-bottom: 0.1rem;
    }

    .sub-title {
        font-size: 0.2rem;
        font-family: Source Han Sans CN;
        font-weight: 400;
        color: #999999;
        margin-bottom: 0.4rem;
    }
}
</style>
